module.exports = __webpack_public_path__ + "static/img/join_12.32c2d9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join_12.png
// module id = GAPa
// module chunks = 0